import React, { useState } from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import TextField from '@mui/material/TextField';
import clsx from 'clsx';
import axios from 'axios';
import Loader from '../../Loader/';

const StepOne = ({
  error,
  setError,
  initialError,
  setStep,
  accountNumber,
  setAccountNumber,
  title,
  description,
  inputLabel,
  inputNote,
  inputPlaceholder,
  maxLength,
  otpButton,
  otpGenerateEndpoint,
  otpGenerateErrorMessage,
  timeout,
  limitationNumber,
  limitationMessage,
  timeoutErrorMessage,
}) => {
  // debugger;
  // Component states
  const [loading, setLoading] = useState(false);
  const [forceDisable, setForceDisable] = useState(false);
  const [forceDisableMessage, setForceDisableMessage] = useState('');
  // Conditional rendering
  const shouldRenderTitle = !!title?.value;
  const shouldRenderDescription = !!description?.value;
  const shouldRenderMaxLength = !!maxLength?.value;
  const shouldRenderOtpButton = !!otpButton?.value;
  const accountNumberMin = 10;

  const LOCAL_STORAGE_ATTEMPT_KEY = 'otpAttemptsStep';
  const LOCAL_STORAGE_DISABLE_OTP_KEY = 'disableGenerateOtpButton';
  const LOCAL_STORAGE_OTP_TIMER_KEY = 'otpDateCanGenerate';

  const getAttemptsStorage = () => {
    if (typeof localStorage !== 'undefined') {
      const attempts = parseInt(
        localStorage.getItem(LOCAL_STORAGE_ATTEMPT_KEY) || limitationNumber?.value
      );
      return attempts;
    }
  };

  const setAttemptsStorage = (attempts) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOCAL_STORAGE_ATTEMPT_KEY, attempts);
    }
  };

  const decrementAttemptsStorage = (dateBlockUntil, numberofRemainingRetries) => { 
    if (typeof localStorage !== 'undefined') {
      // localStorage.setItem(LOCAL_STORAGE_DISABLE_OTP_KEY, new Date());
      let attempt = getAttemptsStorage();
      const newAttemptStorage =
        typeof numberofRemainingRetries !== 'undefined' && numberofRemainingRetries !== attempt - 1
          ? numberofRemainingRetries
          : attempt - 1;
      // console.log('decrementAttemptsStorage newAttemptStorage,', newAttemptStorage);
      if (newAttemptStorage === 0) {
        // showError('fe limit reached decrementAttemptsStorage');
        showError(`${limitationMessage?.value}`);

        if (!!dateBlockUntil) {
          localStorage.setItem(LOCAL_STORAGE_DISABLE_OTP_KEY, dateBlockUntil);
        }

        if (new Date() >= dateBlockUntil) {
          setAttemptsStorage(limitationNumber?.value);
        }
        // console.log('decrementAttemptsStorage dateBlockUntil,', dateBlockUntil);
      } else {
        setAttemptsStorage(newAttemptStorage);
      }
    }
  };

  const showError = (message) => {
    // disable button
    setForceDisable(true);
    setForceDisableMessage(message);
    // show error
  };

  // errorCode = "TimeElapsed" "errorMessage": "Could not generate OTP, as the OTP has already been sent in last 60 seconds",
  // errorCode = "LimitReached"

  const userCanSend = () => {
    // debugger;
    if (typeof localStorage !== 'undefined') {
      const dateBlockUntil = localStorage.getItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
      const attempts = getAttemptsStorage();

      const OTPDateBlockUntil = localStorage.getItem(LOCAL_STORAGE_OTP_TIMER_KEY);
      const arrayOTPTimerCreatedAndNotEmpty =
        !!OTPDateBlockUntil && Object.keys(OTPDateBlockUntil).length > 0;
      //check time difference of OTPDateBlockUntil

      const OTPDateBlockUntilDate = new Date(OTPDateBlockUntil);

      const stillOTPTimerFrozen =
        !!arrayOTPTimerCreatedAndNotEmpty && new Date() <= OTPDateBlockUntilDate; // date logic comapre date now  with isDisbaledUntil

      // console.log('new Date()', new Date());
      // console.log('OTPDateBlockUntil', OTPDateBlockUntil);
      // console.log('new Date() <= OTPDateBlockUntil', new Date() <= OTPDateBlockUntilDate);
      // console.log('arrayOTPTimerCreatedAndNotEmpty', arrayOTPTimerCreatedAndNotEmpty);
      // console.log('stillOTPTimerFrozen,', stillOTPTimerFrozen);
      // console.log(
      //   `s2 userCanSend arrayCreatedAndNotEmpty ${arrayCreatedAndNotEmpty}, dateBlockUntil: ${dateBlockUntil}`
      // );
      const arrayCreatedAndNotEmpty = !!dateBlockUntil && Object.keys(dateBlockUntil).length > 0;
      //check time difference of dateBlockUntil
      const stillFrozen =
        attempts <= 0 && !!arrayCreatedAndNotEmpty && new Date() <= dateBlockUntil; // date logic comapre date now  with isDisbaledUntil

      const isDisbaled = false;

      if (!stillFrozen) {
        // delete the local storage of LOCAL_STORAGE_DISABLE_OTP_KEY
        localStorage.removeItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
        // console.log('userCanSend !stillFrozen', true);
        //start add
        if (!stillOTPTimerFrozen) {
          // console.log('!stillOTPTimerFrozen');
          // delete the local storage of LOCAL_STORAGE_DISABLE_OTP_KEY
          localStorage.removeItem(LOCAL_STORAGE_OTP_TIMER_KEY);
          // console.log('userCanSend !stillFrozen', true);
          return true;
        } else if (!isDisbaled) {
          // console.log('stillOTPTimerFrozen !isDisbaled');
          // console.log('userCanSend stillFrozen', false);
          return false;
        }
        //add end

        // return true;
      } else if (!isDisbaled && attempts === 0) {
        // console.log('userCanSend stillFrozen', false);

        return false;
      }
      // console.log('userCanSend default', true);

      return true;
    }
  };
  // Generate otp listener
  const generateOtp = async () => {
    // console.log('generateOtp');
    // We make sure that the user inputs are correct
    if (!(accountNumber?.length >= accountNumberMin)) return;
    try {
      if (userCanSend()) {
        // To show the loader while the request is being processed
        setLoading(true);
        const generateSMS = await axios.get(
          otpGenerateEndpoint?.value?.replace('{reference}', accountNumber)
        );

        // START setting interval of otp generation
        if (typeof localStorage !== 'undefined') {
          let otpDateBlockUntil = new Date(); // new Date(parseInt(dateString.slice(6, -2)));
          otpDateBlockUntil.setSeconds(
            otpDateBlockUntil.getSeconds() + timeout?.value // add oTPLimitResetDurationInMinutes
          );

          localStorage.setItem(LOCAL_STORAGE_OTP_TIMER_KEY, otpDateBlockUntil);
        }
        // END

        // const timestamp = date.getTime();
        let dateBlockUntil = null;
        // console.log('b4 dateBlockUntil', dateBlockUntil);
        const attempts = getAttemptsStorage();
        if (
          attempts === 0 ||
          generateSMS?.data?.output?.numberofRemainingRetries === 0 ||
          generateSMS?.data?.output?.errorCode === 'LimitReached'
        ) {
          showError(`${generateSMS?.data?.output?.errorMessage}`);
          dateBlockUntil = new Date(); // new Date(parseInt(dateString.slice(6, -2)));
          dateBlockUntil.setMinutes(
            dateBlockUntil.getMinutes() + generateSMS?.data?.output?.oTPLimitResetDurationInMinutes // add oTPLimitResetDurationInMinutes
          );
        }
        if (generateSMS?.data?.output?.errorCode !== 'TimeElapsed') {
          // console.log('b4 attempts', attempts);
          decrementAttemptsStorage(
            dateBlockUntil,
            generateSMS?.data?.output?.numberofRemainingRetries
          );
          // console.log(`after attempts ${attempts} after dateBlockUntil ${dateBlockUntil}`);
        } else {
          // debugger;
          const OTPDateBlockUntil = localStorage.getItem(LOCAL_STORAGE_OTP_TIMER_KEY);
          const OTPDateBlockUntilDate = new Date(OTPDateBlockUntil);
          const diffInSeconds = Math.ceil(
            Math.abs((new Date().getTime() - OTPDateBlockUntilDate.getTime()) / 1000)
          );

          //Could not generate OTP, as the OTP has already been sent in last ${0} seconds
          // showError(`${timeoutErrorMessage?.value}`);
          let msg = timeoutErrorMessage?.value?.replaceAll('${0}', diffInSeconds);
          // console.log('diffInSeconds', diffInSeconds);
          // console.log('timeoutErrorMessage?.value', timeoutErrorMessage?.value);
          // console.log('msg', msg);
          showError(msg);
        }
        if (generateSMS?.data?.output?.success === '0') {
          if (
            generateSMS?.data?.output?.errorCode !== 'LimitReached' &&
            generateSMS?.data?.output?.errorCode !== 'TimeElapsed'
          ) {
            setError((prev) => {
              prev[0].status = true;
              prev[0].msg = otpGenerateErrorMessage?.value || '';
              return prev;
            });
          }
        } else {
          setStep(1);
        }
      }
    } catch (err) {
      console.log('Error in generating OTP', err);
    } finally {
      setLoading(false);
    }
  };

  const checkGenerateButton = () => {
    if (typeof localStorage !== 'undefined') {
      const disableGenerateOtpButtonValue = localStorage.getItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
      let disabledUntil = new Date(disableGenerateOtpButtonValue);

      const OTPDateBlockUntil = localStorage.getItem(LOCAL_STORAGE_OTP_TIMER_KEY);
      const OTPDateBlockUntilDate = new Date(OTPDateBlockUntil);
      const stillOTPTimerFrozen = new Date() <= OTPDateBlockUntilDate;
      const diffInSeconds = Math.ceil(
        Math.abs(new Date().getTime() - OTPDateBlockUntilDate.getTime()) / 1000
      );

      console.log('diffInSeconds', diffInSeconds);

      if (stillOTPTimerFrozen) {
        let msg = timeoutErrorMessage?.value?.replaceAll('${0}', diffInSeconds);
        showError(msg);

        // console.log('frozen');
      }
      // console.log('disabledUntil', disabledUntil);
      if (!!disableGenerateOtpButtonValue) {
        if (new Date() <= disabledUntil) {
          // still frozen we shot error and prevent next step
          showError(`${limitationMessage?.value}`);
          // showError(t('otpGenerateErrorMessage'));
        } else {
          // frozen time is reached and we need to clear the local storage and allow the user to send again
          localStorage.removeItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
          setAttemptsStorage(limitationNumber?.value);
          generateOtp();
        }
      } else {
        generateOtp();
      }
    }
  };
  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="row">
        <div className="col-12 col-lg-6 left-side">
          {shouldRenderTitle && (
            <h3>
              <Text field={title} />
            </h3>
          )}
          {shouldRenderDescription && <RichText field={description} className="left-side-desc" />}
          <div className="input-container">
            <TextField
              InputLabelProps={{ className: 'form-element-label' }}
              error={error[0].status}
              className="account-input form-element"
              label={inputLabel?.value || ''}
              helperText={!error[0]?.status ? inputNote?.value || '' : error[0].msg}
              placeholder={inputPlaceholder?.value || ''}
              value={accountNumber
                .replace(/[^\dA-Z]/g, '')
                .replace(/(.{4})/g, '$1 ')
                .trim()}
              type="tel"
              fullWidth
              inputProps={
                !shouldRenderMaxLength
                  ? {}
                  : { maxLength: maxLength.value + Math.ceil(maxLength.value / 4) - 1 }
              }
              onFocus={() =>
                setError((prev) => {
                  prev[0].status = false;
                  prev[0].msg = '';
                  return prev;
                })
              }
              onChange={(e) => setAccountNumber(e.target.value.replace(/\s/g, '').trim())}
            />
            {shouldRenderMaxLength && (
              <div className="input-track">
                {accountNumber.replace(/ /g, '').length}/{shouldRenderMaxLength && maxLength.value}
              </div>
            )}
          </div>
          <button
            className={clsx(
              'button button-contained-primary generate-btn',
              (!(accountNumber?.length >= accountNumberMin) || forceDisable) && 'disabled-btn'
            )}
            onClick={checkGenerateButton}
          >
            {shouldRenderOtpButton ? <Text field={otpButton} /> : ''}
          </button>

          {forceDisable && <div className="generic-error">{forceDisableMessage}</div>}
        </div>
      </div>
    );
  }
};

export default StepOne;
